import { Dialog, Flex, Portal } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import IconClose from '@/components/icons/IconClose'
import { H3 } from '@/components/ui/Headings'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  children: ReactNode
  maxW?: string
  showCloseButton?: boolean
}

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxW = '508px',
  showCloseButton = true
}: ModalProps) {
  const handleOpenChange = (details: { open: boolean }) => {
    if (!details.open) {
      onClose()
    }
  }

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={handleOpenChange}
      placement="center"
    >
      <Portal>
        <Dialog.Backdrop bg="blackAlpha.600" />
        <Dialog.Positioner>
          <Dialog.Content
            maxW={maxW}
            w="full"
            bg="white"
            borderRadius="16px"
            px={8}
            py={5}
            pb={8}
            position="relative"
          >
            {title && (
              <Flex justify="space-between" align="center" mb="14px">
                <Dialog.Title asChild>
                  <H3 fontWeight={500} color="black.500">
                    {title}
                  </H3>
                </Dialog.Title>
                {showCloseButton && (
                  <Dialog.CloseTrigger
                    asChild
                    position="absolute"
                    top="20px"
                    right="20px"
                  >
                    <IconClose
                      boxSize="20px"
                      color="secondaryGray.400"
                      cursor="pointer"
                    />
                  </Dialog.CloseTrigger>
                )}
              </Flex>
            )}
            <Dialog.Body p={0}>{children}</Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
